import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink
} from 'mdb-react-ui-kit';
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { get } from "../../Services/RestAPIService";
import { Link, useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import Dummy from "../../assets/images/No_Image_Available.jpg"

const DatatableTables = ({ t }) => {

  const navigate = useNavigate();
  const [data, setData] = useState({
    columns: [
      {
        label: t("ID"),
        field: "id",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Exercise Name"),
        field: "exercise_name",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Status"),
        field: "status",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Image"),
        field: "image",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Category"),
        field: "category_name",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Edit"),
        field: "edit",
        sort: "asc",
        width: 100,
      },
    ],
    rows: []
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);

  const getExercisesData = async (page) => {
    try {
      const exerciseData = await get(`exercise/exercises/?page=${page}`);
      setTotalPages(exerciseData.total_pages);

      // Mapping API response to fit the table rows
      const modifiedRows = exerciseData.results.map(exercise => ({
        id: exercise.id,
        exercise_name: exercise.exercise_name,
        status: exercise.status ? t("Active") : t("Inactive"),
        image: <img src={exercise.image || Dummy} alt="Exercise" width="50" height="50" />,
        category_name: exercise.category_id ? exercise.category_id.name : "N/A",
        edit: <Button color="secondary" onClick={() => handleEdit(exercise.id)}>{t("Edit")}</Button>,
      }));

      // Updating the state with modified rows
      setData(prevState => ({
        ...prevState,
        rows: modifiedRows
      }));
    } catch (error) {
      console.error('Error fetching exercise data:', error);
    }
  };

  useEffect(() => {
    getExercisesData(currentPage);
  }, [currentPage]);

  const handleCheckboxChange = (id) => {
    const updatedSelectedRows = [...selectedRows];
    const index = updatedSelectedRows.indexOf(id);
    if (index === -1) {
      updatedSelectedRows.push(id);
    } else {
      updatedSelectedRows.splice(index, 1);
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleTableChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleEdit = (id) => {
    navigate(`/category/edit-exercise/id/${id}`);
    console.log("Edit button clicked for exercise with ID:", id);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle={t("Home")} title={t("Data")} breadcrumbItem={t("Exercises")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>


                <div className="d-flex justify-content-between align-items-center mb-4">
                  <CardTitle className="h4">{t("Exercises")}</CardTitle>
                  <Button color="primary" onClick={() => navigate(`/category/create-exercise/id/${"id"}`)}>
                    <i className="typcn typcn-plus"></i> {t("Add New Exercise")}
                  </Button>
                </div>


                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging={false}
                    data={{
                      columns: data.columns,
                      rows: data.rows
                    }}
                    className="custom-cursor-pointer"
                  />

                 

                  <MDBPagination className='mt-3'>
                    <MDBPaginationItem disabled={currentPage === 1}>
                      <MDBPaginationLink onClick={() => handleTableChange(currentPage - 1)} tabIndex="-1" aria-disabled={currentPage === 1}>
                        {t("Previous")}
                      </MDBPaginationLink>
                    </MDBPaginationItem>
                    {[...Array(totalPages).keys()].map(page => (
                      <MDBPaginationItem key={page + 1} active={currentPage === page + 1}>
                        <MDBPaginationLink onClick={() => handleTableChange(page + 1)}>
                          {page + 1}
                        </MDBPaginationLink>
                      </MDBPaginationItem>
                    ))}
                    <MDBPaginationItem disabled={currentPage === totalPages}>
                      <MDBPaginationLink onClick={() => handleTableChange(currentPage + 1)}>
                        {t("Next")}
                      </MDBPaginationLink>
                    </MDBPaginationItem>
                  </MDBPagination>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(DatatableTables);
